import React from 'react';

interface ChartSectionProps {
  title: string;
  icon: React.ReactNode;
  isExpanded: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  className?: string;
}

export const ChartSection: React.FC<ChartSectionProps> = ({
  title,
  icon,
  isExpanded,
  onToggle,
  children,
  className
}) => (
  <div className={`bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm ${className ?? ''}`}>
    <div className="px-2 sm:px-4 py-2 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-700 rounded-t-lg">
      <div className="flex items-center justify-between gap-1">
        <div className="flex items-center gap-1 sm:gap-2 min-w-0 flex-1">
          {icon}
          <h2 className="text-xs sm:text-sm font-semibold text-gray-900 dark:text-white truncate">{title}</h2>
        </div>
        <button
          onClick={onToggle}
          className="p-1 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
          title={isExpanded ? 'Collapse section' : 'Expand section'}
        >
          <svg
            className={`w-5 h-5 text-gray-500 dark:text-gray-400 transition-transform ${isExpanded ? '' : 'rotate-180'}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </div>
    </div>
    {isExpanded && children}
  </div>
);
